'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../style/CardSection.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardSection = function CardSection(_ref) {
  var className = _ref.className,
      renderProp = _ref.renderProp;
  return _react2.default.createElement(
    'div',
    null,
    renderProp('cp-card-section ' + className)
  );
};

CardSection.propTypes = {
  className: _react.PropTypes.string,
  renderProp: _react.PropTypes.func.isRequired
};

exports.default = CardSection;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/card/base/lib/components/CardSection.component.js
// module id = 655
// module chunks = 5 9